import { BuildTypes } from "../constants";

type UrlSet = Record<(typeof BuildTypes)[keyof typeof BuildTypes], string>;

export enum Services {
    MY_LENSES_GRAPHQL = "my-lenses-graphql",
    GRAPHQL_FEDERATION = "graphql-federation",
    INSIGHTS_LENS_STUDIO_WEB = "insights-lens-studio-web",
}

// Api Gateway
const API_GATEWAY_STAGING = "https://staging-gcp.api.snapchat.com";
const API_GATEWAY_PROD = "https://gcp.api.snapchat.com";

// My Lenses API Gateway Staging
// my-lenses-gateway.snap-dev.net is an alias for staging-us-central1-gcp.api.snapchat.com
// Need separate domain to pass SSO credentials
// It has the following mapping in Service Mesh's
// my-lenses-gateway_snap-dev_net > my-lenses-graphql-pp.gcp-us-central1.STAGING-to-STAGING
// my-lenses-gateway_snap-dev_net > remote-api-admin.gcp-us-central1.STAGING-to-STAGING
const API_GATEWAY_MY_LENSES_STAGING = "https://my-lenses-gateway.snap-dev.net";
const API_GATEWAY_MY_LENSES_PRE_PROD = "https://my-lenses.snapchat.com";

// PATHS
// My Lenses GraphQL
const MY_LENSES_GRAPHQL_PATH = "/graphql";
const GRAPHQL_FEDERATION_PATH = "/gfg-mylenses/";
const INSIGHTS_LENS_STUDIO_WEB_PATH = "/insights-lens-studio-web/graphql";

export const SNAP_ROUTE_TAG = "X-Snap-Route-Tag";
export const PRE_PROD_TAG = "pre-prod";
export const APOLLO_OPERATION_NAME_HEADER = "x-apollo-operation-name";

// Remote API Admin
export const urlMap: Record<Services, UrlSet> = {
    [Services.GRAPHQL_FEDERATION]: {
        [BuildTypes.local]: MY_LENSES_GRAPHQL_PATH, // TODO: figure out local setup for gql federation
        [BuildTypes.dev]: `${API_GATEWAY_STAGING}${GRAPHQL_FEDERATION_PATH}`,
        [BuildTypes.preProd]: `${API_GATEWAY_PROD}${GRAPHQL_FEDERATION_PATH}`,

        [BuildTypes.prod]: `${API_GATEWAY_PROD}${GRAPHQL_FEDERATION_PATH}`,
    },
    [Services.MY_LENSES_GRAPHQL]: {
        [BuildTypes.local]: MY_LENSES_GRAPHQL_PATH,
        [BuildTypes.dev]: `${API_GATEWAY_MY_LENSES_STAGING}${MY_LENSES_GRAPHQL_PATH}`,
        [BuildTypes.preProd]: `${API_GATEWAY_MY_LENSES_PRE_PROD}${MY_LENSES_GRAPHQL_PATH}`,

        [BuildTypes.prod]: MY_LENSES_GRAPHQL_PATH,
    },
    [Services.INSIGHTS_LENS_STUDIO_WEB]: {
        [BuildTypes.local]: `${API_GATEWAY_STAGING}${INSIGHTS_LENS_STUDIO_WEB_PATH}`,
        [BuildTypes.dev]: `${API_GATEWAY_STAGING}${INSIGHTS_LENS_STUDIO_WEB_PATH}`,

        [BuildTypes.preProd]: `${API_GATEWAY_PROD}${INSIGHTS_LENS_STUDIO_WEB_PATH}`,
        [BuildTypes.prod]: `${API_GATEWAY_PROD}${INSIGHTS_LENS_STUDIO_WEB_PATH}`,
    },
};
